import * as api from '../../services/facet/api_facet';
import * as apiCommon from '../../services/apiCommon';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as SagaCommon from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* fetchListFacetSaga(feathersApp) {
    yield takeLatest('FETCH_LIST_FACET', callFetchListFacet, feathersApp);
}

function* callFetchListFacet(feathersApp, action) {
    const { silent, filters } = action;
    yield SagaCommon.showProgressListTable(silent);
    try {
        const dataParams = { 
            filters, 
            list_type: 'facet'
        };
        const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
        yield call(SagaCommon.doneListTable, { rows: tableData.data, total_rows: tableData.total });
    } catch (error) {
        yield SagaCommon.showErrorListTable(error);
    }
}

export function* saveFacetSaga(feathersApp) {
  yield takeEvery("SAVE_FACET", callSaveFacet, feathersApp);
}
function* callSaveFacet(feathersApp, action) {
  const { tenant, user } = yield select();
  try{
      yield put({ type: 'SAVE_RECORD_INPROGRESS' });

      const params = { tenant, user, data: action.data };
      const result = yield call(api.saveFacet, feathersApp, params );

      yield SagaCommon.doneSaveRecord( result, 'Facet was saved' );
      yield put({
        type: SagasType.SIMPLE_FORM_SET_DATA,
        data: result
      });
      yield callFetchListFacet(feathersApp, { silent: true });

  } catch (e){
    yield SagaCommon.showErrorSaveRecord(e);
  }
}

export function* deleteFacetFromListSaga(feathersApp) {
    yield takeEvery('DELETE_FACET_FROM_LIST', callDeleteFacetFromList, feathersApp);
}

function* callDeleteFacetFromList(feathersApp, action) {
    yield deleteFacet(feathersApp, action);
    yield callFetchListFacet(feathersApp, { silent: true });
}

function* deleteFacet(feathersApp, action) {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });
    try {
        const { id } = action;
        let result = null;
        if(id) {
            const state = yield select();
            const { tenant, user } = state;
            const params = { tenant, user, id };
            result = yield call(api.deleteFacet, feathersApp, params);
            yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.FACET }});
            yield callFetchListFacet(feathersApp, { silent: true });
        }
        return result;
    } catch (error) {
        yield put({ type: 'DELETE_RECORD_ERROR', error })
    }
}

export function* deleteFacetSaga(feathersApp) {
    yield takeEvery('DELETE_FACET', callDeleteFacet, feathersApp);
}

function* callDeleteFacet(feathersApp, action) {
    const result = yield deleteFacet(feathersApp, action);
    yield delay(2000); 
    if(result) {
        browserHistory.push('/admin/facet');
    }
}

export function* fetchFacetForEditSaga(feathersApp) {
    yield takeEvery('FETCH_FACET_BY_ID', callFetchFacetForEdit, feathersApp);
}

function* callFetchFacetForEdit(feathersApp, action) {
    const { tenant, user } = yield select();
    const { id } = action;
    const docType = DocType.FACET;
    try {
        if(id) {
            yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
            const fetchParams = { tenant, user, id };
            const doc = yield call(api.fetchFacetById, feathersApp, fetchParams);
            yield SagaCommon.doneDataById(doc);
            yield put({
                type: SagasType.SIMPLE_FORM_SET_DATA,
                data: doc
              });
        }
    } catch (error) {
        yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
    }
}
